<template>
  <div class="page dark intro">
    <div class="inner">
      
        <div id="select">
          <h1>Equipment</h1>
          <div id="buttons">
            <button :class="[studio==0?'selected':'']" @click="studio=0">Studio A</button>
            <button :class="[studio==1?'selected':'']" @click="studio=1">Studio B</button>
          </div>
        </div>
   
          <p>The following equipment can be available on sessions booked using <strong>{{ studio==1?'Control Room B': 'Control Room A' }}</strong></p>
     
            <div id="equipment-grid">
            <div v-for="(section, head, i) in equipmentList[studio]" class="section" :id = "'s-'+ section['id']">
              
                <div  class="section-head">{{head}}</div>
                <div class="subsection" v-for="(subsection, subhead, i) in section" v-if="subhead != 'id'">
                  <div class="subsection-head" v-if="subhead">{{subhead}}</div>
                  <ul>
                    <li v-for="equipment in subsection">{{ equipment }}</li>
                  </ul>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'equipment',
  data: function(){
    return {
      studio: 0,
      equipmentList:[{
       "Computer": {id:'computer', 'Apple': ["Mac Mini (6-core i7 3.2GHz, 32GB RAM, OSX Mojave)"], 'PC':["Inta Audio Evo i7 Quad Core, 16GB RAM, SSD Program Drive, 1TB Data Drive, Windows 7 (64 bit)", "Intel i7 Quad Core, 16GB RAM, 3x 1TB Hard Drives, Windows 7 (64 bit)"], 
                      'Software': ["Steinberg Cubase Pro 10", "Logic Pro X", "Steinberg WaveLab Elements 9.5", "Audacity", "Adobe Premiere Elements 11", "Adobe Photoshop Elements 11", "Pinnacle Studio 16 Ultimate"], 'Control Surfaces':['Icon QCon Pro G2 (24 channels)']} , 
       "Outboard": {id:'interface', 'Interface':["Antelope Audio Orion 32+"], "Preamps":["Warm Audio WA273-EQ (4ch Neve style)", "Warm Audio WA412 (12ch API style)", "Focusrite OctoPre MkII (8ch)"], 'Compressors':['Warm Audio WA-76 ×2 (1176 style)', 'Warm Audio WA-2A ×2 (LA2A style)'], 'EQ': ['Warm Audio WA273-EQ (4ch Neve 1073 style)', 'Warm Audio EQP-WA (Pultec style tube EQ)'], 'Misc':["Reverb", "Digital Delay", "Headphone distribution"]},
       
       "Microphones & DI": {id:'microphones', 'Warm Audio':["Warm Audio WA47", "Warm Audio WA87 ×2", "Warm Audio WA84 ×2"], 'sE Electronics':["sE Titan T2 (Titanium)", "sE 4400 ×2", "sE R1 Ribbon ×2", "sE Z3300A ×4",
                       "sE X1-T (Tube)", "sE X1-D (Titanium)",  "sE 5", "sE 4 ×2", "sE H1"], "AKG": ["AKG C1000S ×2", "AKG D112", "AKG D22"], "Shure":["Shure SM81", "Shure SM7b", "Shure SM57 ×6", 
                       "Shure SM58", "Shure PG58"], 'Rupert Neve Designs': ['RNDI'], 'Misc': ['Dual DI Box ×2',  "Ultra-G DI Box"]},
       "Acoustics & Isolation": {id:'isolation', '':["GIK Portable Isolation Booth ×3", "GIK 4A Alpha Panel Diffusor / Absorber ×4", "GIK 6A Alpha Panel Diffusor / Absorber ×2", "sE SPACE Reflexion Filter", "sE IRF ×6", "Auralex Hoverdeck and Hovermat Drum Kit Isolators", "Auralex Mudguard Microphone Isolator ×2"]},
       "Monitors & PA": {id:'monitors', '':["Adam A7X", "Presonus Eris E44", "Celestion 1200W PA"]},
       "Headphones": {id:'headphones', 'Beyerdynamic':["DT770 PRO", "DT150", "DT100"], "Sennheiser": ["eH250"]},
       "Mixer": {id:'mixer', '':["Studiomaster 16-2"]},
       
      "Instruments":  {id:'instruments', 'Keys':["1973 Calisia Upright Piano", "Alesis V61 Midi Keyboard"], 'Guitars':["Epiphone G-400",
                      "Gretsch Double Jet", "Sigma Acoustic Guitar", "Sigma 12 String Acoustic Guitar"], 'Bass':["Vintage Electric Bass"], 'Amps & Cabs':["Marshall Origin ×2", "Orange Crush 30R",
                      "Marshall Haze 15 Head", "Laney Lionheart 1x12", "Marshall 4x12", "Peavey Special 1x12", "Ashdown Vintage 12 Bass Amp"]}
                      ,
      "Plugins": {id:'plugins', 'Antelope': ["FGPA FX (Orion 32+)"], 'Slate Digital': ["Virtual Mix Rack", "FG-X Mastering Unit", "Virtual Tape Machines", "Virtual Console Collection", "Virtual Preamp Collection."],
                                'Focusrite': ["Midnight Suite", "Scarlett Suite"],
                                'Native Instruments (FX)': ["Solid EQ, Solid Dynamics"," Solid Bus Comp", "VC 76 Compressor", "VC 2A Compressor", "VC 160 Compressor", "Supercharger", "Replika Delay", "RC 24 Reverb", "RC 48 Reverb"],
                                'Native Instruments (Virtual Instruments)': ["Symphony Series Collection (full version)", "Mallet Flux", "Soundiron Vocal Suite", "Grandeur Piano", "The Gentleman Piano", "The Maverick Piano", "Action Strings", "Session Strings", "Drum Lab",
                               "Heavoycity Evolve", "Discovery Series West Africa", "Discovery Series Cuba", "Abbey Road 60's Drummer, Abbey Road 70's Drummer",
                               "Komplete Elements Selection."]

        }

      },
      {
        "Computer": {id:'computer',  'Apple': ["Mac Mini (6 Core 3GHz, 8GB Ram, OSX Mojave)", "Mac Pro 1,1 (Quad Core Xeon, 32GB Ram, OSX Yosemite)."], "Software": ["Logic Pro X"], "Control Surfaces":["Softube Console 1"]},
        "Outboard": {id:'interface', 'Interface': ["Antelope Audio Discrete 8 (8ch)"], "Preamps":["Audient ASP800 (8ch)"], "Misc":["Headphone distribution"]},
        "Microphones": {id:'microphones', 'Antelope': ['Edge Solo'], 'sE Electronics':[
                       "sE Z3300A", "sE X1-T (Tube)", "sE X1-D (Titanium)",  "sE 5", "sE 4 ×2", "sE H1"], "AKG": ["AKG C1000S ×2", "AKG D112", "AKG D22"], "Shure":["Shure SM7b", "Shure SM57 ×6", 
                       "Shure SM58", "Shure PG58"], 'DI':['Dual DI Box ×2', "Ultra-G DI Box"]},
        "Acoustics & Isolation": {id:'isolation', '':["GIK Portable Isolation Booth ×3", "GIK 4A Alpha Panel Diffusor / Absorber ×4", "GIK 6A Alpha Panel Diffusor / Absorber ×2", "sE SPACE Reflexion Filter", "sE IRF ×6", "Auralex Hoverdeck and Hovermat Drum Kit Isolators", "Auralex Mudguard Microphone Isolator ×2"]},

        "Mixer": {id:'mixer', '':["Allen & Heath ZED12FX","Studiomaster 16-2"]},
        "Monitors & PA": {'id':'monitors', '':["Mackie MR8", "Celestion 1200W PA"]},
        "Headphones": {id:'headphones', 'Beyerdynamic':["DT770 PRO", "DT150", "DT100"], "Sennheiser": ["eH250"]},
        
        "Plugins": {id:'plugins', 'Antelope':['Discrete 8 Premium FX'], 'Softube':["SSL 4000e (Console 1)", 
                    "Trident A-Range (EQ)", "Weiss MM-1 Mastering Maximizer", "FET Compressor", "Amp Room Essentials", "Fix Flanger", "Fix Doubler", "TSAR-1R (reverb)", "Tube Delay", "Drawmer S73 Intelligent Master Processor"],
                    "McDSP": ["EC-300 (delay)"],
                    "Waves":["Scheps Omni Channel (channel strip)"],
                    "Exponential Audio": ["R2 (reverb)"], 
                    "D16": ["Syntorus (chorus)", "Sigmund (delay)"],
                    "Focusrite": ["Red 2 (EQ)", "Red 3 (compressor)"],
                    "Novation": ['Bass Station'],
                    "XLN": ["Adictive Keys: Studio Grand"],
                    "iZotope": ["Ozone 8 Elements"]
                    },
        "Instruments": {id:'instruments', 'Amps & Cabs':["Black Star Series One (10-100W, EL34)", "Orange Tiney Terror (7/15W)", "Marshall 1936 2x12 cab (Celestion Greenback)"], 'Keys':["1973 Calisia Upright Piano", "Alesis V61 Midi Keyboard"] ,
        "Guitar Pedals & FX": ["Line 6 Helix LT", "Catlinbread Belle Epoch (echoplex tape delay)", "TC Electronic Hall of Fame mini (reverb)",
                              "TC Electronic Spark Boost Mini", "TC Electronic Polytune", "Vox Big Bad Wah (Joe Satriani signature wah)."]}
      }

    ]
    }
  }
}
</script>

<style scoped lang="scss">
    button{
      padding:1em;
      background-color:rgb(72, 28, 67);
      border:2px solid rgb(36, 5, 25);
      border-radius: 10px;
      font-size: 90%;
      margin:0.25em;
      color: white;
      &:hover{
        background-color:rgb(106, 58, 100);
        cursor: pointer;
      }
    }
.selected{
  background-color: rgb(120, 61, 115);
  font-weight: bold;
}
#select{
  display:flex;
  align-items: flex-start;
  background-image:url('../assets/bgpurple.png');
  
  width:100%;
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  padding-top:80px;

  z-index: 100;
  h1{
    flex:1 1 auto;
    padding-top:0.5em;
    padding-bottom:0;
    color:rgb(196, 137, 198);
  }
}
#buttons{
  flex:0 0 200px;
  text-align:right;
}
.intro{

  display: flex;
  align-items: center;
  justify-content: center;
  .inner{
    max-width: 1200px;
    
    padding:0 2%;

  }
}
#equipment-grid{
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr 1fr;

}
.section{
  border:1px solid rgba(255,255,255,0.2);
  background-color:rgba(0,0,0,0.2);
  margin:0.25em;
}
.section ul{
  padding:0;
  margin:0;
  li{
    text-decoration: none;
    list-style: none;
    padding-left:1.5em;
    padding-right: 1em;
    border-bottom:1px solid rgba(255,255,255,0.1)
  }
  li:nth-child(even){
    background-color:rgba(255,255,255,0.02);
  }
  li:nth-child(odd){
    background-color:rgba(255,255,255,0.04);
  }
}

.section-head{
  position: sticky;
  top:130px;///80px;
  z-index: 50;
  background-color: rgb(19, 2, 21);//rgba(0,0,0,0.4);
  padding:0.8em;
  padding-bottom: 0.2em;
  font-weight:bold;
  color:rgb(238, 197, 125);
  border-bottom:2px solid rgba(0,0,0,0.7);
  border-right:2px solid rgba(0,0,0,0.7);
}
.subsection-head{
  font-weight: bold;
  color:rgb(238, 197, 125);
  padding-left:0.8em;
    background-color:rgba(0,0,0,0.2);
    border-bottom:2px solid rgba(0,0,0,0.7);
}
#s-computer{
  grid-row-end: span 2;
}
#s-microphones{
  grid-row: 1/span 2;
  grid-column: 2/ span 1;
}
#s-instruments{
  grid-row: 3 / span 2;
  grid-column: 2 / span 1;
}
#s-plugins{
  grid-row: 1/span 3;
  grid-column: 3/span 1;
}
#s-instruments{
  grid-row-end: span 2;
}
h1{
  margin-bottom:0.6em;
}

@media only screen and (max-width: 800px) {
  h1{
    font-size:x-large;
  }
  #equipment-grid{
    grid-template-columns: 1fr 1fr ;
    grid-template-rows: 1fr 1fr 1fr 1fr;
  }
  #s-microphones{
    grid-row: 1/ span 2;
    grid-column: 2/-1;
  }
  #s-plugins{
  grid-row: 3/span 3;
  grid-column: 1/span 1;
}
}

@media only screen and (max-width: 600px) {
  #equipment-grid{
    display: block;
  }
  .intro{
    .inner{
        padding:0 0%;
    }
  }
  button{
    padding:0.5em;
    margin-top:0.5em;
  }
}
</style>
